export default {"src":"/_next/static/media/advantages-icon-4.5aa030eb.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};